import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/fieldReport/${':fieldReportId' | number}/subJob/${':subJobId' | number}/billableWork/${':billableWorkId' | number}/findForWorkSummary`;

export const ROUTE: RouteDefinition = `${baseRoute}/fieldReport/:fieldReportId/subJob/:subJobId/billableWork/:billableWorkId/findForWorkSummary`;

export const URL = (fieldReportId: number, subJobId: number, billableWorkId: number): RouteDefinition => (
	`${baseRoute}/fieldReport/${fieldReportId}/subJob/${subJobId}/billableWork/${billableWorkId}/findForWorkSummary`
);
